import { gql } from '@apollo/client'

export const GET_ALL_WATER_TRUCKS = gql`
  query GetAllWaterTruckRequests(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filtersWaterTruckRequest
  ) {
    getAllWaterTruckRequests(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      rows {
        id
        user_id_created
        volume
        priority
        type_delivery
        status_id
        provider_id
        folio
        planning_date
        completed_at
        createdAt
        is_extemporaneous
        comments
        UserOfWaterTruckRequest {
          id
          type_user
          name
          first_name
          last_name
          email
          jurisdiction_id
          # sub_jurisdiction_id
          # group_category_id
        }
        StatusOfWaterTruckRequest {
          id
          name
          progress
          color
          type
        }
        ProviderOfWaterTruckRequest {
          id
          card_code
          card_name
          type
          rfc
          phone
          email
          logo
        }
        AddressOfWaterTruckRequest {
          address_full
        }
        RoutesOfWaterTruckRequest {
          id
          truck_id
          RouteToTrucks {
            plate_number
          }
        }
        ZonesOfWaterTruckRequest {
          name
        }
        ColonyOfWaterTruckRequest {
          name
          nocolonia
        }
      }
      count
    }
  }
`

export const GET_WATER_TRUCK_BY_ID = gql`
  query GetOneWaterTruckRequestById($id: Int!) {
    getOneWaterTruckRequestById(id: $id) {
      id
      user_id_created
      volume
      priority
      type_delivery
      status_id
      provider_id
      folio
      planning_date
      completed_at
      comments
      UserOfWaterTruckRequest {
        id
        type_user
        name
        first_name
        last_name
        email
        phone
        RoleOfUser {
          role_name
          description
        }
      }
      StatusOfWaterTruckRequest {
        id
        name
        progress
        color
        type
      }
      ProviderOfWaterTruckRequest {
        id
        card_code
        card_name
        type
        rfc
        phone
        email
      }
      AddressOfWaterTruckRequest {
        id
        latitude
        longitude
        address_full
      }
      AttachmentsOfWaterTruckRequest {
        id
        water_truck_request_id
        user_id_created
        url
        type_file
        UserOfWaterTruckRequestAttachment {
          id
          type_user
          name
          first_name
          last_name
          email
          phone
          RoleOfUser {
            role_name
          }
        }
      }
      ZonesOfWaterTruckRequest {
        name
      }
      ColonyOfWaterTruckRequest {
        name
        nocolonia
      }
    }
  }
`

export const GET_ALL_WATER_TRUCKS_REQUEST_BY_CONCILIATION_ID = gql`
  query GetAllWaterTruckRequestByConciliationId(
    $conciliationId: Int!
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllWaterTruckRequestByConciliationId(
      conciliation_id: $conciliationId
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        user_id_created
        volume
        priority
        type_delivery
        status_id
        provider_id
        folio
        planning_date
        createdAt
        completed_at
        is_extemporaneous
        UserOfWaterTruckRequest {
          id
          type_user
          name
          first_name
          last_name
          email
          # jurisdiction_id
          # sub_jurisdiction_id
          # group_category_id
        }
        StatusOfWaterTruckRequest {
          id
          name
          progress
          color
          type
          progress
          color
        }
        ProviderOfWaterTruckRequest {
          id
          card_code
          card_name
          type
          rfc
          phone
          email
          logo
        }
        AddressOfWaterTruckRequest {
          address_full
        }
        RoutesOfWaterTruckRequest {
          id
          truck_id
          RouteToTrucks {
            plate_number
          }
        }
      }
      count
    }
  }
`

export const CREATE_WATER_TRUCK = gql`
  mutation CreateWaterTruckRequest($input: inputWaterTruckRequest!) {
    createWaterTruckRequest(input: $input) {
      id
      user_id_created
      volume
      priority
      type_delivery
      status_id
      provider_id
      folio
      planning_date
      completed_at
    }
  }
`
export const UPDATE_WATER_TRUCK = gql`
  mutation UpdateWaterTruckRequest($updateWaterTruckRequestId: Int!, $input: inputWaterTruckRequest!) {
    updateWaterTruckRequest(id: $updateWaterTruckRequestId, input: $input)
  }
`
export const DELETE_WATER_TRUCK = gql`
  mutation DeleteWaterTruckRequest($id: Int!) {
    deleteWaterTruckRequest(id: $id)
  }
`

export const CHANGE_STATUS_WATER_TRUCK = gql`
  mutation ChangeStatusWaterTruckRequest(
    $input: inputChangeStatusWaterTruckRequest!
  ) {
    changeStatusWaterTruckRequest(input: $input)
  }
`

export const GET_WATER_TRUCKS_IDS_AVAILABLE_CONCILIATION = gql`
  mutation GetWaterTrucksIdsAvailableConciliation(
    $dateTo: String!
    $dateFrom: String!
  ) {
    getWaterTrucksIdsAvailableConciliation(dateTo: $dateTo, dateFrom: $dateFrom)
  }
`

export const CHANGE_STATUS_TO_EXTEMPORANEOUS_WATER_TRUCK = gql`
  mutation ChangeRequestToExtemporaneous($id: Int!) {
    changeRequestToExtemporaneous(id: $id)
  }
`

export const CHANGE_WATER_TRUCK_STATUS = gql`
mutation ChangeWaterTruckStatus($changeWaterTruckStatusId: Int!, $statusId: Int!) {
  changeWaterTruckStatus(id: $changeWaterTruckStatusId, status_id: $statusId)
}
`
